const categories = [
  {
    name: 'Category',
    hasChildren: true,
    isSelected: false,
    children: [
      {
        name: 'Bottoms',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Pajamas',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Fashion Sets',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Robes',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Uniforms',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Waterproof Jackets',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Reversible',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Retro Fashion',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Dance Wear',
        isSelected: false,
        hasChildren: false
      },
      {
        name: 'Beach Wear',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Overalls',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Capes',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Costumes & Cosplay',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'U-Necks',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Custom Made Clothing',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Business Casual',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Shorts',
        hasChildren: false,
        isSelected: false
      },
      {
        name: 'Plus Size Fashion',
        hasChildren: false,
        isSelected: false
      }
    ]
  }
]

export default categories



// WEBPACK FOOTER //
// ./src/assets/js/category.js